module.exports = __webpack_public_path__ + "img/7.e72f46d6.jpg";